import React from 'react';
import blockStyles from '@baseStyles/block.scss';
import styles from './Footer.scss';
import PS from "./PS/PS";
import PSData from "./PS/data/PSData";
import PaymentMethods from "./PaymentMethods/PaymentMethods";
import PaymentMethodsData from "./PaymentMethods/data/PaymentMethodsData";
import LinksRow from "./Links/LinksRow";
import LinksData from "./Links/data/LinksData";
import SocialContainer from "./SocialContainer/SocialContainer";
import SocialContainerData from "./SocialContainer/data/SocialContainerData";
import ContactContainer from "./ContactContainer/ContactContainer";
import ContactContainerData from "./ContactContainer/data/ContactContainerData";

const Footer = ({color = '', noMarginTop = false}) => {
	return (
	  <div className={`${styles.container} ${color ? blockStyles[color] : ''} ${noMarginTop ? styles.noMarginTop : ''}`}>
		  <div className={styles.holder}>
			  <ContactContainer data={ContactContainerData}/>
			  <SocialContainer data={SocialContainerData}/>
			  <LinksRow data={LinksData}/>
			  <PaymentMethods data={PaymentMethodsData}/>
			  <PS data={PSData}/>
		  </div>
	  </div>
	);
}

export default Footer;
